
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import { mapState, mapActions } from 'vuex'
export default {
name: 'App',
directives: {
TransferDom
},
components: {
Popup,
Loading
},
data () {
return {
text1: '正在加载'
}
},
created () {
let loading = document.getElementById('Loading')
if (loading != null) {
document.body.removeChild(loading)
}
},
computed: {




isLoading () {
return this.$store.state.isLoading
},
direction () {
return this.$store.state.direction
},
...mapState({}) // 为了使方法一不报语法错误




},








methods: {
...mapActions([
'updateDemoPosition'
])
}
}



// WEBPACK FOOTER //
// ./src/App.vue